module.exports = __webpack_public_path__ + "media/images/psp/passed-e4d5fa8ea2a6f3b82825938a71b16bbf.svg";